jQuery(function ($) {
  $.fn.isOnScreen = function () {
    var win = $(window);

    var viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft(),
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(
      viewport.right < bounds.left ||
      viewport.left > bounds.right ||
      viewport.bottom < bounds.top ||
      viewport.top > bounds.bottom
    );
  };

  jQuery(document).ready(function () {
    if ($(".animatedFadeInUp").isOnScreen()) {
      TriggerCounters();
    }
  });

  $(window).scroll(function () {
    var scrollTop = $(document).scrollTop();
    if ($(".about-us-banner").length !== 0) {
      var SectionPosition = $(".about-us-banner").offset().top;
      if (scrollTop > SectionPosition) {
        TriggerCounters();
      }
    } else if ($(".banner_header_section").length !== 0) {
      var SectionPosition = $(".banner_header_section").offset().top;
      if (scrollTop > SectionPosition) {
        TriggerCounters();
      }
    }
  });

  $(document).ready(function () {
    // jQuery("a.member-popup").on("click", function () {
    //   var member_id = jQuery(this).attr("member_id");
    //   if (!$('.team-popup-content[member_id="' + member_id + '"]').hasClass("open-popup")) {
    //     jQuery(".team-popup-content").removeClass("open-popup");
    //     jQuery(".main").prepend('<div class="overlay" id="space"></div>');
    //     $('.team-popup-content[member_id="' + member_id + '"]').addClass(
    //       "open-popup"
    //     );
    //     jQuery("html").css("overflow", "hidden");
    //   }
    // });

    // jQuery(document).on("click", ".overlay", function () {
    //   jQuery(this).remove();
    //   // jQuery(this).hide();
    //   jQuery("html").css("overflow", "auto");
    //   jQuery(".team-popup-content.open-popup").removeClass("open-popup");
    // });

    // jQuery("span.close-icon").on("click", function () {
    //   jQuery(".overlay").remove();
    //   // jQuery(".overlay").hide();
    //   jQuery("html").css("overflow", "auto");
    //   jQuery(".team-popup-content.open-popup").removeClass("open-popup");
    // });

    // jQuery(document).keyup(function (e) {
    //   if (e.key === "Escape") {
    //   jQuery(".overlay").remove();
    //     // jQuery(".overlay").hide();
    //     jQuery("html").css("overflow", "auto");
    //     jQuery(".team-popup-content.open-popup").removeClass("open-popup");
    //   }
    // });

    jQuery(document).on("click", "a.video-popup", function () {
      var youtube_url = jQuery(this).attr("href");
      if (youtube_url) {
        jQuery.fancybox({
          type: "iframe",
          wrapCSS: "youtube-video",
          href: youtube_url,
          onComplete: function () {
            jQuery("#fancybox-frame").attr(
              "allowfullscreen",
              "allowfullscreen"
            );
          },
          beforeShow: function () {
            if (jQuery(".video-testimonials").length) {
              jQuery(".video-testimonials")
                .owlCarousel()
                .trigger("stop.owl.autoplay");
            }
          },
          afterClose: function () {
            if (jQuery(".video-testimonials").length) {
              jQuery(".video-testimonials")
                .owlCarousel()
                .trigger("play.owl.autoplay", [5000]);
            }
          },
        });
        return false;
      } else {
        return false;
      }
    });
  });
});
function TriggerCounters() {
  jQuery(".animatedFadeInUp").each(function (index) {
    var CounterElement = jQuery(this).find("p.count");
    var DataValue = CounterElement.attr("data-value");

    jQuery(this)
      .prop("Counter", 0)
      .animate(
        { Counter: DataValue },
        {
          duration: 6000,
          easing: "swing",
          step: function (now) {
            CounterElement.text(Math.ceil(now) + "+");
          },
        }
      );
    (function (that, i) {
      //jQuery(that).addClass('fadeInUp');
      var t = setTimeout(function () {
        jQuery(that).find("span").addClass("shadow");
      }, 1000 * i);
    })(this, index);
  });
}



// WEBPACK FOOTER //
// ./scripts/about-us/script.js